<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-toolbox"></i>Select Invoice to Send
    </h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="busy" class="col-md-12 text-center">
    <img src="./assets/images/preloader.gif" />
  </div>
  <div class="modal-body" *ngIf="!busy">
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label>Customer Name</label><br />
          <strong class="invoice_customername_text">{{ customerName }}</strong>
        </div>
        <div class="form-group">
          <label>Selected Invoices</label><br />
          <strong class="invoice_selectedinvoices_text">{{
            selectedRowsString
          }}</strong>
        </div>
      </div>
      <div class="col-md-12" style="padding-top: 10px">
        <ngb-alert type="info" [dismissible]="false"
          >Please tick the checkbox to select the Invoice/s to send.</ngb-alert
        >
      </div>
    </div>
    <ag-grid-angular
      *ngIf="!busy"
      style="width: 100%"
      class="ag-theme-material invoice_invoicelist_grid"
      [rowData]="invoiceDataSource | async"
      (gridReady)="onGridReady($event)"
      [rowSelection]="'multiple'"
      [rowMultiSelectWithClick]="true"
      (selectionChanged)="onSelectionChanged($event)"
      [pagination]="true"
      [paginationPageSize]="10"
      [columnDefs]="invoiceColumns"
    >
    </ag-grid-angular>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline invoice_send_button"
      (click)="onSend()"
      [disabled]="busy || selectedRowsString.length === 0"
    >
      <i class="fas fa-mail-bulk"></i> Send
    </button>
  </div>
</div>
